import React, {useState} from "react";

import {useParams} from "react-router";
import {useQuery} from "react-query";

import {i18n} from "../../../translate/i18n";
import {useUser} from "../../../store/providers/app";
import {newHeaderTable, newRowsTable} from "../../../utils/actions";
import {Editable} from "../../../components/Table/editable";
import {getGoal} from "../../../services/Goals.service";

const FormTable = () => {

    let {id} = useParams();
    let { user } = useUser()

    const [tables, setTables] = useState([]);
    const [data, setData] = useState([]);


    const {isFetching} = useQuery(['indicator', id],
        () => {
            return getGoal(id)
        }, {
            onSuccess: (res) => {
                const response = res.data.data
                const {tables} = response

                setData(response)

                setTables(JSON.parse(JSON.stringify(tables)))
            },
            retry: 2,
            refetchOnWindowFocus: false,
            retryOnMount: false
        }
    )

    const handleNewTable = () => {
        setTables([...tables, {
            indicator_id: id,
            title: '',
            headers: newHeaderTable,
            rows: newRowsTable,
        }])
    }

    const handleRemoveTable = (position) => {
        setTables([...tables.filter((_, index) => index !== position)])
    }

    return (
        <>
            { user.profile !== 7 &&
                <div className="d-flex justify-content-end mb-4">
                    <button type="button" className="btn btn-outline-success px-3 py-2"
                            onClick={() => handleNewTable()}>
                        <i className="bi bi-plus" /> {i18n.t('label.newTable')}
                    </button>
                </div>
            }

            { tables.map((table, index) =>
                <div key={index} className="accordion" id={`accordion-${index+1}`}>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id={`heading-${index+1}`}>
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${index+1}`} aria-expanded="false"
                                    aria-controls={`collapse-${index+1}`}>
                                {table.titulo}
                            </button>
                        </h2>
                        <div id={`collapse-${index+1}`} className="accordion-collapse collapse" aria-labelledby={`heading-${index+1}`} data-bs-parent={`#accordion-${index+1}`}>
                            <div className="accordion-body p-0">
                                <Editable
                                    data={table}
                                    codigo={data?.codigo}
                                    removeData={handleRemoveTable}
                                    index={index}
                                    idEn={data.id_en}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}



export default FormTable
